import { render } from "./Summaryprojection.vue?vue&type=template&id=4f4bd134&scoped=true"
import script from "./Summaryprojection.vue?vue&type=script&lang=js"
export * from "./Summaryprojection.vue?vue&type=script&lang=js"

import "./Summaryprojection.vue?vue&type=style&index=0&id=4f4bd134&scoped=true&lang=css"

import exportComponent from "/Users/alexisbailly/Documents/Programming/Website/vueform/Wealth & Retirement/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f4bd134"]])

export default __exports__